<!--
* UIID: UI-CAAS-COM-110
* UI Name: FTP
* Modify Date: 2020/06/15
-->
<template>
  <v-card>
    <v-card-text>
      <v-form ref="form" lazy-validation class="px-4" style="height: 595px; overflow: auto">
        <!-- First Row -->
        <v-row>
          <v-col cols="12" md="4" class="mt-6">
            <font class="text-base font-bold leading-snug textcolor5--text">
              {{ $t('lbl.communications.ftps') }}
            </font>
            <v-text-field
              v-model="formData.name"
              :rules="
                formData.name && formData.name.length > 50
                  ? ['Max 50 characters']
                  : [validationUtils.required]
              "
              :error-messages="formError.name.message"
              placeholder="Enter the name"
              ref="name"
              :autofocus="true"
              solo
              :disabled="!$auth.manage"
              class="mt-5"
            ></v-text-field>
          </v-col>
          <!-- // 2021.8.30 203728 SPKA-201 remove partner from communication -->
          <!-- <v-col cols="12" md="4">
            <v-select
              v-model="formData.partner"
              :items="partners"
              :placeholder="$t('lbl.common.conditionSearch.selectPartner')"
              solo
              :menu-props="{ offsetY: true, }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col> -->
          <!-- 203665 2021/03/03
            SPKA-44 Remove Direction on screen Communication 
          -->
          <!-- <v-col cols="12" md="4">
            <v-select
                v-model="formData.direction"
              :items="inouts"
              :placeholder="$t('lbl.common.conditionSearch.selectDirection')"
              solo
              :menu-props="{ offsetY: true, }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col> -->
        </v-row>
        <!-- 2 Row 54px-->
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Host</v-label>
            <v-text-field
              v-model="formData.host"
              :rules="[validationUtils.required, validationUtils.min(8), validationUtils.max(100)]"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="8" class="pr-0">
                <v-label>Security</v-label>
                <v-select
                  v-model="formData.security"
                  :items="securities"
                  solo
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Port</v-label>
                <v-text-field
                  v-model="formData.port"
                  type="number"
                  :rules="[validationUtils.required, validationUtils.max(5)]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row><v-col cols="12" md="12" class="h-2"></v-col></v-row>
        <!--3 Row 40px-->
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>User ID</v-label>
            <v-text-field
              v-model="formData.userid"
              :rules="[validationUtils.required, validationUtils.max(200)]"
              solo
              :disabled="!$auth.manage"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="8" class="pr-0">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Password</v-label>
                <v-text-field
                  v-model="passwordField"
                  :append-icon="formData.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="formData.showpassword ? 'text' : 'password'"
                  @click:append="formData.showpassword = !formData.showpassword"
                  :rules="passwordRules"
                  :readonly="isPasswordViewMode"
                  solo
                  :disabled="!$auth.manage"
                  autocomplete="new-password"
                  @focus="handlePasswordType"
                  @blur="handlePasswordType"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn
                  v-if="isPasswordViewMode"
                  class="btn btn-popup-search mt-7"
                  block
                  height="40"
                  color="primary"
                  @click="startEditPassword"
                >
                  Change
                </v-btn>
                <v-btn
                  v-else-if="hasStoredPassword"
                  class="btn btn-close mt-7"
                  block
                  height="40"
                  @click="cancelEditPassword"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row><v-col cols="12" md="12" class="h-2"></v-col></v-row>
        <!--4 Row -->
        <v-row>
          <v-col cols="12" md="6" class="px-4" style="position: relative;">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Down/Upload Path</v-label>
            <v-text-field
              v-model="formData.path"
              :rules="[validationUtils.required, validationUtils.max(200)]"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
            <v-checkbox
              v-model="formData.ftpAutoDir"
              label="Auto Create FTP Directory"
              dense
              true-value="Y"
              false-value="N"
              hide-details="true"
              class="ftp-auto-dir"
            ></v-checkbox>
          </v-col>
          <!-- // 2021.8.9 203728  SPKA-178 Add "Filename Pattern" to communication (only for FTP, sFTP) -->
          <v-col cols="12" md="6" class="px-4">
            <v-label>{{ $t('lbl.communications.getFileNmPttn') }}</v-label>
            <v-text-field
              v-model="formData.fileNmPttn"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row><v-col cols="12" md="12" class="h-2"></v-col></v-row>
        <!--5 Row -->
        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" md="6" class="pr-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.communications.exeInterval') }}</v-label
                >
                <v-text-field
                  v-model="formData.interval"
                  type="number"
                  :rules="[validationUtils.required, validateInterval(intervalDefault)]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="intervalDefault"
                  :items="intervals"
                  solo
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                  return-object
                  class="select-interval"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <!-- /**
            * 2021.09.28 203737 SPKA-218 Add item in Communication (FTP, sFTP)
            */ -->
          <v-col cols="12" md="6" class="px-4">
            <v-row class="ml-0 mr-0  d-block">
              <v-col lg="11" class="pa-0">
                <v-label>{{ $t('lbl.communications.putFileNmPttn') }}</v-label>
              </v-col>
              <v-tooltip top :disabled="listPattern.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <v-col lg="1" class="pa-0 mb-1 text-right">
                      <v-icon
                        dense
                        @click="addPattern()"
                        :disabled="!$auth.manage || listPattern.length >= maxPattern"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-row>
            <v-form ref="formHttpHeaders" class="dialog-content form-identification pr-0">
              <v-row
                class="ml-0 mr-0 mb-4 edi-identification"
                v-for="(item, index) in listPattern"
                :key="item.id"
              >
                <v-col cols="12" md="7" class="pa-0">
                  <v-tooltip top :disabled="!item.isValidatePattern">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-select
                          :ref="'PTTN_' + item.id"
                          v-model="item.keyPattern"
                          :items="listComboFilenamePattern"
                          solo
                          :menu-props="{ offsetY: true }"
                          :disabled="!$auth.manage"
                          @change="validatePattern(item)"
                          :rules="item.isValidatePattern ? [''] : []"
                        ></v-select>
                      </div>
                    </template>
                    <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="3" class="pa-0 ml-2">
                  <v-text-field
                    :ref="'PTTN_' + item.id + '_' + item.id"
                    solo
                    hide-details
                    v-model="item.valuePattern"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="pa-0 mt-2 text-right">
                  <v-icon dense @click="removePattern(index)">
                    mdi-minus
                  </v-icon>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" class="pr-0">
            <v-label>{{ $t('lbl.communications.maxRetryAttempts') }}</v-label>
            <v-text-field
              v-model="formData.maxRetry"
              type="number"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <dialogWindow
      ref="DuplicatePatternDialog"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    >
    </dialogWindow>
  </v-card>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { getEditData } from '@/vue-caas/utils/process';

const PWD_DUMMY = '••••••••••••';

export default {
  components: {
    dialogWindow,
  },
  props: {
    item: {
      type: Object,
    },
    // 2021.8.30 203728 SPKA-201 remove partner from communication
    // prnrList: {
    //   type: Array,
    // },
  },

  data() {
    return {
      securities: [
        { text: 'NONE', value: 'NONE' },
        { text: 'SSL', value: 'SSL' },
        { text: 'TLS', value: 'TLS' },
      ],
      // 2021.8.30 203728 SPKA-201 remove partner from communication
      // partners: [
      //   {value: 'INT', text: 'INTTRA'},
      //   {value: 'ONE', text: 'ONE'},
      //   {value: 'SO', text: 'SmartLink Platform'},
      //   {value: 'PORTE', text: 'PORTEVER'},
      //   {value: 'FL', text: 'Faircon Line'},
      //   {value: 'ULS', text: 'ULS'},
      //   {value: 'WooW', text: 'WooWon'},
      //   {value: 'IMPEX', text: 'IMPEX'}
      // ],
      inouts: [
        { value: 'I', text: 'INBOUND' },
        { value: 'O', text: 'OUTBOUND' },
      ],
      formData: {},
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
      intervals: [
        { text: this.$t('msg.communications.seconds'), value: 'SS' },
        { text: this.$t('msg.communications.minutes'), value: 'MM' },
        { text: this.$t('msg.communications.hours'), value: 'HH' },
      ],
      intervalDefault: {
        text: this.$t('msg.communications.minutes'),
        value: 'MM',
      },
      listComboFilenamePattern: [],
      listPattern: [],
      setPattern: new Set(),
      isValidatePattern: false,
      listPatternType: [],
      maxPattern: 0,
      isDuplicatePattern: false,
      checkDialogColor: 'warning',
      checkDialogInfo: '',
      passwordState: 'unchanged',
      hasStoredPassword: false,
      editingPassword: false,
    };
  },

  computed: {
    isPasswordViewMode() {
      return this.hasStoredPassword && !this.editingPassword;
    },

    passwordField: {
      get() {
        return this.isPasswordViewMode ? PWD_DUMMY : this.formData.password;
      },
      set(v) {
        if (this.isPasswordViewMode) return;
        this.formData.password = v;
        this.passwordState = v.length ? 'replace' : 'unchanged';
      },
    },

    passwordRules() {
      if (this.isPasswordViewMode) return [];
      if (this.hasStoredPassword) return [this.validationUtils.max(20)];
      return [this.validationUtils.required, this.validationUtils.max(20)];
    },
  },

  created() {
    this.formData = Object.assign({}, this.getInitData(), this.item);
    // 05/24/2021 203737 SPKA-115 issue 63 Add interval type in communication component
    if (!this.formData.interval) {
      this.formData.interval = '30';
    }
    // 2021.8.30 203728 SPKA-201 remove partner from communication
    // this.partners = this.prnrList;
    // 05/05/2021 203737 SPKA-90 Modify the "File check Interval" in communication
    if (this.item.intervalType) {
      this.intervalDefault = this.intervals.filter(
        (item) => item.value === this.item.intervalType,
      )[0];
    }

    this.hasStoredPassword = Boolean(this.item && this.item.hasPassword);
    this.formData.password = '';
    this.formData.showpassword = false;
    this.passwordState = 'unchanged';
    this.editingPassword = !this.hasStoredPassword;

    this.loadFormData = Object.assign({}, this.getInitData(), this.item);
    this.loadFormData.password = '';
    this.loadFormData.showpassword = false;

    this.getListComboFilenamePattern();
  },

  watch: {
    item() {
      this.resetFormData();
      this.setFocus();
    },
  },

  methods: {
    startEditPassword() {
      this.editingPassword = true;
      this.formData.showpassword = false;
      this.formData.password = '';
      this.passwordState = 'unchanged';
      this.$nextTick(() => this.$refs.passwordInput?.focus());
    },

    cancelEditPassword() {
      this.editingPassword = false;
      this.formData.showpassword = false;
      this.formData.password = '';
      this.passwordState = 'unchanged';
    },

    handlePasswordType(event) {
      const { srcElement, type } = event;
      const { value } = srcElement;
      if (type === 'focus' && !value) {
        this.formData.showpassword = false;
      }
      if (type === 'blur' && !value) {
        this.formData.showpassword = true;
      }
    },
    async save() {
      const indexValidPattern = this.listPattern.findIndex(
        (e) => e.keyPattern === '' || e.valuePattern === '',
      );
      if (indexValidPattern > -1) {
        const itemPattern = this.listPattern[indexValidPattern];
        this.$refs[
          `PTTN_${itemPattern.id}${itemPattern.keyPattern === '' ? '' : '_' + itemPattern.id}`
        ][0].focus();
        return -1;
      }
      if (this.isDuplicatePattern) {
        this.$refs.DuplicatePatternDialog.dialog = true;
        this.checkDialogInfo = this.$t('msg.communications.validDuplicatePattern');
        return -1;
      }
      this.listPatternType.forEach((item) => {
        this.formData[item] = null;
      });
      this.listPattern.forEach((item) => {
        this.formData[item.keyPattern] = item.valuePattern;
      });

      /* 
        2021/03/08 203737 Seperator when select FTP and FTP(s)
      */
      if (!this.formData.security || this.formData.security == 'NONE') {
        this.formData.type = 'FTP';
      } else {
        this.formData.type = 'FTPS';
      }

      // 05/05/2021 203737 SPKA-90 Modify the "File check Interval" in communication
      if (this.intervalDefault && this.intervalDefault.value) {
        this.formData.intervalType = this.intervalDefault.value;
      }

      this.formData.protocol = this.formData.type;

      let submitData;

      if (this.formData.action == 'edit') {
        /* 
        2021/01/15 203665 workflow issue 21  send only edit Data to JSON
      */
        submitData = getEditData(this.formData, this.loadFormData);
        submitData.id = this.formData.id;
        if (submitData.name === undefined) {
          submitData.name = this.formData.name;
        }
        submitData.type = this.formData.type;
        submitData.protocol = this.formData.type;

        if (this.passwordState === 'replace' && this.formData.password) {
          submitData.password = this.formData.password;
        } else {
          delete submitData.password;
        }
        delete submitData.showpassword;

        await this.$store.dispatch('editComm', submitData);
        await this.sendActivate(this.formData.id, 'COM', submitData);
      } else {
        submitData = { ...this.formData };
        delete submitData.showpassword;
        await this.$store.dispatch('insertComm', submitData);
      }
      this.resetFormData();
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },
    /* 
      2021/01/15 203665 workflow issue 21  send only edit Data to JSON
    */

    getInitData() {
      return {
        name: '',
        partner: '',
        direction: '',
        host: '',
        security: '',
        port: '',
        userid: '',
        password: '',
        showpassword: true,
        path: '',
        interval: '',
        type: 'FTPS',
        ftpAutoDir: false,
      };
    },
    // hasEditForm() {
    //   const defaultForm = this.getInitData();
    //   for (const prop in defaultForm) {
    //     if (prop != 'showpassword' && prop != 'type') {
    //       if (this.formData[prop].trim() != '') {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // },
    resetFormData() {
      if (this.item.type == 'FTPS' || this.item.type == 'FTP') {
        this.formData = Object.assign({}, this.getInitData(), this.item);
        this.$refs.form.resetValidation();
        this.formData.password = '';
        this.formData.showpassword = false;
        this.passwordState = 'unchanged';
        this.editingPassword = !this.hasStoredPassword;
      }
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.name.focus();
      }, 300);
    },
    validateInterval(item) {
      let interval = this.formData.interval;
      if (interval) {
        switch (item.value) {
          case 'SS': {
            // 05/31/2021 203737 SPKA-127 issue 76 Change minimum interval value for "Seconds" from 30 to 10. (validation allow 10~59 seconds)
            if (interval < 10 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['10', '59', 'seconds']);
            }
            break;
          }
          case 'HH': {
            if (interval < 1 || interval > 24) {
              return this.$t('msg.communications.validateInterval', ['1', '24', 'hours']);
            }
            break;
          }
          default: {
            if (interval < 1 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['1', '59', 'minutes']);
            }
          }
        }
      }
      return true;
    },
    getListComboFilenamePattern() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P10' }).then(() => {
        this.$store.getters['caascommon/comCdList'].map((e) => {
          this.listComboFilenamePattern.push({ text: e.text, value: e.value });
        });
        this.getListPatternType();
      });
    },
    addPattern() {
      let index =
        this.listPattern.length > 0 ? this.listPattern[this.listPattern.length - 1].id + 1 : 1;
      this.listPattern.push({
        id: index,
        keyPattern: '',
        valuePattern: '',
        isValidatePattern: false,
      });
    },
    removePattern(index) {
      this.listPattern.splice(index, 1);
      this.resetSetPattern();
    },
    validatePattern(itemChange) {
      let indexValid = this.listPattern.findIndex((e) => e.id === itemChange.id);
      if (this.setPattern.has(itemChange.keyPattern)) {
        this.isDuplicatePattern = true;
        this.listPattern[indexValid].isValidatePattern = true;
      } else {
        this.isDuplicatePattern = false;
        this.listPattern[indexValid].isValidatePattern = false;
      }
      this.resetSetPattern();
    },
    getListPatternType() {
      this.listComboFilenamePattern.map((item) => {
        this.listPatternType.push(item.value);
      });
      Object.keys(this.formData).map((item, index) => {
        if (this.listPatternType.includes(item) && this.formData[item]) {
          let obj = {
            id: index + 1,
            keyPattern: item,
            valuePattern: this.formData[item],
            isValidatePattern: false,
          };
          this.listPattern.push(obj);
          this.setPattern.add(item);
        }
      });
      this.maxPattern = this.listPatternType.length;
    },
    resetSetPattern() {
      this.setPattern.clear();
      this.listPattern.map((item) => {
        if (item.keyPattern !== '') {
          this.setPattern.add(item.keyPattern);
        }
      });
    },
    closeDialog() {
      this.$refs.DuplicatePatternDialog.dialog = false;
    },
  },
};
</script>
<style>
.communication-patterns {
  min-height: 60px;
  max-height: 70px;
  overflow-y: auto;
}
</style>
